import styles from "./ColorBox.module.scss";
import React, { useCallback, useState } from "react";
import clsx from "clsx";
import ClickAwayListener from "react-click-away-listener";

export const DEFAULT_COLOR = "#555555|#FFFFFF";

const ColorBox = ({value, onChange, right = false}) => {
  const [presetsShown, setPresetsShown] = useState(false);

  const [background, color] = (value || DEFAULT_COLOR).split("|");

  const selectColor = useCallback(preset => () => {
    onChange(preset.background + "|" + preset.color);

    setPresetsShown(false);
  }, [onChange]);

  return (
    <div className={clsx(styles.colorBox, right ? styles.right : null)}>
      <ClickAwayListener onClickAway={e => setPresetsShown(false)}>
        <div>
          <div className={styles.preview} style={{background, color}} onClick={() => setPresetsShown(true)}>A</div>

          <div className={clsx(styles.presets, presetsShown ? styles.shown : null)}>
            {presets.map(preset => {
              const active = preset.background === background && preset.color === color;

              return <div key={preset.background + preset.color}
                          className={clsx(styles.colorBoxItem, active ? styles.active : null)}
                          style={{background: preset.background, color: preset.color}}
                          onClick={selectColor(preset)}
              >A</div>;
            })}
          </div>
        </div>
      </ClickAwayListener>
    </div>
  );
};

const presets = [
  {background: "#fbdfdf", color: "#ae1313"},
  {background: "#fbeddf", color: "#ae6113"},
  {background: "#fcf9e8", color: "#b89c14"},
  {background: "#f0fbdf", color: "#6eae13"},
  {background: "#dffbe6", color: "#13ae3a"},
  {background: "#dffbf9", color: "#13aea1"},
  {background: "#dff2fb", color: "#137bae"},
  {background: "#dfe8fb", color: "#1347ae"},
  {background: "#e6dffb", color: "#3a13ae"},
  {background: "#f4dffb", color: "#8813ae"},
  {background: "#fbdfed", color: "#ae1361"},
  {background: "#f5f5f5", color: "#1a1a1a"},
  {background: "#f8afaf", color: "#840b0b"},
  {background: "#f8d4af", color: "#84470b"},
  {background: "#faf0bd", color: "#927c0c"},
  {background: "#daf8af", color: "#52840b"},
  {background: "#aff8c1", color: "#0b8429"},
  {background: "#aff8f2", color: "#0b847a"},
  {background: "#afe0f8", color: "#0b5c84"},
  {background: "#afc7f8", color: "#0b3384"},
  {background: "#c1aff8", color: "#290b84"},
  {background: "#e6aff8", color: "#660b84"},
  {background: "#f8afd4", color: "#840b47"},
  {background: "#e0e0e0", color: "#1a1a1a"},
  {background: "#f76e6e", color: "#490404"},
  {background: "#f7b36e", color: "#492604"},
  {background: "#f8e37c", color: "#574905"},
  {background: "#bef76e", color: "#2c4904"},
  {background: "#6ef790", color: "#044915"},
  {background: "#6ef7ec", color: "#044943"},
  {background: "#6ec9f7", color: "#043249"},
  {background: "#6e9cf7", color: "#041b49"},
  {background: "#906ef7", color: "#150449"},
  {background: "#d56ef7", color: "#370449"},
  {background: "#f76eb3", color: "#490426"},
  {background: "#c7c7c7", color: "#1a1a1a"},
  {background: "#f42525", color: "#fee7e7"},
  {background: "#f48c25", color: "#fef2e7"},
  {background: "#f4d434", color: "#302903"},
  {background: "#9df425", color: "#f4fee7"},
  {background: "#25f459", color: "#e7feed"},
  {background: "#25f4e2", color: "#e7fefc"},
  {background: "#25aff4", color: "#e7f6fe"},
  {background: "#256af4", color: "#e7eefe"},
  {background: "#5925f4", color: "#ede7fe"},
  {background: "#c025f4", color: "#f8e7fe"},
  {background: "#f4258c", color: "#fee7f2"},
  {background: "#a6a6a6", color: "#1a1a1a"},
  {background: "#cb1010", color: "#fde7e7"},
  {background: "#cb6e10", color: "#fdf2e7"},
  {background: "#d9b812", color: "#fdf9e7"},
  {background: "#7dcb10", color: "#f4fde7"},
  {background: "#10cb3f", color: "#e7fded"},
  {background: "#10cbbb", color: "#e7fdfb"},
  {background: "#108dcb", color: "#e7f6fd"},
  {background: "#104fcb", color: "#e7effd"},
  {background: "#3f10cb", color: "#ede7fd"},
  {background: "#9c10cb", color: "#f8e7fd"},
  {background: "#cb106e", color: "#fde7f2"},
  {background: "#808080", color: "#ffffff"},
  {background: "#931010", color: "#f8c3c3"},
  {background: "#935210", color: "#f8dec3"},
  {background: "#a18912", color: "#faf3d1"},
  {background: "#5c9310", color: "#e2f8c3"},
  {background: "#109331", color: "#c3f8d1"},
  {background: "#109388", color: "#c3f8f4"},
  {background: "#106793", color: "#c3e7f8"},
  {background: "#103c93", color: "#c3d5f8"},
  {background: "#311093", color: "#d1c3f8"},
  {background: "#721093", color: "#ebc3f8"},
  {background: "#931052", color: "#f8c3de"},
  {background: "#616161", color: "#ffffff"},
  {background: "#620e0e", color: "#f09898"},
  {background: "#62380e", color: "#f0c498"},
  {background: "#706010", color: "#f2e5a6"},
  {background: "#3f620e", color: "#ccf098"},
  {background: "#0e6223", color: "#98f0ae"},
  {background: "#0e625b", color: "#98f0e9"},
  {background: "#0e4662", color: "#98d3f0"},
  {background: "#0e2a62", color: "#98b6f0"},
  {background: "#230e62", color: "#ae98f0"},
  {background: "#4d0e62", color: "#da98f0"},
  {background: "#620e38", color: "#f098c4"},
  {background: "#404040", color: "#ffffff"},
  {background: "#380a0a", color: "#e77474"},
  {background: "#38210a", color: "#e7ad74"},
  {background: "#453c0c", color: "#e9d881"},
  {background: "#25380a", color: "#b7e774"},
  {background: "#0a3816", color: "#74e791"},
  {background: "#0a3834", color: "#74e7dd"},
  {background: "#0a2938", color: "#74c0e7"},
  {background: "#0a1938", color: "#749ae7"},
  {background: "#160a38", color: "#9174e7"},
  {background: "#2d0a38", color: "#ca74e7"},
  {background: "#380a21", color: "#e774ad"},
  {background: "#1f1f1f", color: "#ffffff"}
];

export default ColorBox;
